import { setClearReducer } from "../reducer/creators"
import { FlashData } from "./FlashData"
import { CLEAR_FLASH, SET_FLASH } from "./actions"

export const flash = setClearReducer<FlashData>([SET_FLASH], [CLEAR_FLASH])
